<template>
    <div class="report-content-line">
        <Card>
            <template v-slot:header>
                <h2>实时数据</h2>
                <span class="icon-info">&nbsp;</span>
                <SelectChartValueType ref="tp1" @change="onTypeChanged"></SelectChartValueType>
            </template>
            <div class="card-content">
                <ChartMap class="chart-normal" ref="chart1"></ChartMap>
            </div>
        </Card>
        <Card>
            <template v-slot:header>
                <h2>累计数据</h2>
                <span class="icon-info">&nbsp;</span>
                <SelectChartValueType ref="tp2" @change="onTypeChanged"></SelectChartValueType>
            </template>
            <div class="card-content">
                <ChartMap class="chart-normal" ref="chart2"></ChartMap>
            </div>
        </Card>
    </div>
</template>
<script>
import ChartMap from "../../../../components/ChartMap.vue";
import SelectChartValueType from "./SelectChartValueType.vue";
export default {
    name: "FlowNow",
    components: {
        SelectChartValueType,
        ChartMap,
    },
    data() {
        return {
            xAxisData: [],
            dataObject: null,
            maxData: 100,
            type: "1",
            searchParam: {},
        };
    },
    mounted() {},
    methods: {
        onTypeChanged(tp) {
            this.type = tp;
            this.$emit("changeType", tp);
        },
        changeType(tp) {
            this.type = tp;
            this.$refs.tp1.change(tp);
            this.$refs.tp2.change(tp);
            this.setData(this.searchParam);
            this.loadData();
        },
        bindData() {
            let opt1 = this.getOptions(this.dataObject.D1);
            let opt2 = this.getOptions(this.dataObject.D2);
            this.$refs.chart1.setData(opt1);
            this.$refs.chart2.setData(opt2);
        },

        setData(data) {
            data.EntityID = data.ID;
            if (data.Time2 == "24:00") {
                data.Time2 = "23:59:59";
            } else if (data.Time2.length < 6) {
                data.Time2 = data.Time2 + ":00";
            }
            if (data.Time1 == "24:00") {
                data.Time1 = "23:59:59";
            } else if (data.Time1.length < 6) {
                data.Time1 = data.Time1 + ":00";
            }
            if (this.type == "1" || this.type == "2" || this.type == "3") {
                data.EndTime = new Date(data.BeginTime).format("yyyy-MM-dd") + " " + data.Time2;
                data.BeginTime = new Date(data.BeginTime).format("yyyy-MM-dd") + " " + data.Time1;
                data.Date = new Date(data.BeginTime);
            } else if (this.type == "4") {
                let Nowdate = new Date(data.BeginTime);
                let WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);
                let WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000);
                data.BeginTime = WeekFirstDay.format("yyyy-MM-dd") + " " + data.Time1;
                data.EndTime = WeekLastDay.format("yyyy-MM-dd") + " " + data.Time1;
                data.Date = data.BeginTime;
            } else if (this.type == "5") {
                let date = new Date(data.BeginTime);
                let MonthFirstDay = new Date(date.getFullYear(), date.getMonth(), 1);
                let MonthNextFirstDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
                var MonthLastDay = new Date(MonthNextFirstDay - 86400000);
                data.BeginTime = MonthFirstDay.format("yyyy-MM-dd") + " " + data.Time1;
                data.EndTime = MonthLastDay.format("yyyy-MM-dd") + " " + data.Time1;
                data.Date = data.BeginTime;
            } else if (this.type == "6") {
                let date = new Date(data.BeginTime);
                let yearFirstDay = new Date(date.getFullYear(), 0, 1);
                let yearLastDay = new Date(date.getFullYear(), 12, 31);
                data.BeginTime = yearFirstDay.format("yyyy-MM-dd") + " " + data.Time1;
                data.EndTime = yearLastDay.format("yyyy-MM-dd") + " " + data.Time1;
                data.Date = data.BeginTime;
            }
            data.TotalType = 1;
            this.searchParam = { ...data };
            this.loadData();
        },
        loadData() {
            this.$ajax.post("/FlowData/GetEntitySection", this.searchParam).then((result) => {
                let arrX = [];
                let arrData1 = [];
                let arrData2 = [];
                let allIn = 0;
                let allOut = 0;
                let allStay = 0;
                for (let i = 0; i < result.Data.length; i++) {
                    arrX.push(result.Data[i].Name);

                    allIn += result.Data[i].DataIn;
                    allOut += result.Data[i].DataOut;
                    let stay = Math.max(allIn - allOut, 0);
                    allStay += stay;
                    if (this.type == "1" || this.type == "4" || this.type == "5" || this.type == "6") {
                        arrData1.push(result.Data[i].DataIn);
                        arrData2.push(allIn);
                    } else if (this.type == "2") {
                        arrData1.push(result.Data[i].DataOut);
                        arrData2.push(allOut);
                    } else if (this.type == "3") {
                        arrData1.push(stay);
                        arrData2.push(allStay);
                    }
                }
                this.xAxisData = arrX;
                this.dataObject = { D1: arrData1, D2: arrData2 };
                this.bindData();
            });
        },
        getOptions(data) {
            let max = 0;
            data.map((r) => (max = Math.max(max, r)));
            let option = {
                color: ["#599bf7", "#ef807c", "#ffc62e", "#ff9631", "#87d14b"],
                title: {},
                tooltip: {
                    show: true,
                    showContent: true,
                    trigger: "axis",
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "40px",
                    containLabel: true,
                },
                toolbox: {
                    feature: {
                        saveAsImage: {},
                    },
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: this.xAxisData,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                series: [
                    {
                        name: "客流量",
                        type: "line",
                        data: data,
                    },
                ],
                yAxis: {
                    type: "value",
                    max: max,
                },
            };
            return option;
        },
    },
};
</script>
